import { captureError } from '@/utils/errorHandler';

/**
 * Copy text to clipboard
 */
export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return { success: true };
  } catch (error) {
    captureError(error, {
      action: 'copyToClipboard',
      component: 'exportUtils',
    });
    console.error('Failed to copy to clipboard:', error);
    return { success: false, error: 'Failed to copy to clipboard' };
  }
}
